import React from "react";
import type { NextPage } from "next";
import Image from "next/image";
import styles from "@/styles/houseOfSenco.module.scss";

const Collecttions = () => {
  return (
    <div className={styles.our_collecttions}>
      <div className={`${styles.container} ${"container"}`}>
        <div className={styles.our_collecttions_head}>
          OUR <strong>COLLECTIONS</strong>
        </div>
        <div className="row g-2">
          <div className="col-md-3">
            <div className={styles.our_collecttions_card}>
              <figure>
                <Image
                  src={require("@/assets/images/Our-Collections/Mens-Jewellery.jpg")}
                  alt="our collecttions"
                />
              </figure>
              <div className={styles.our_collecttions_text}>
                <div className="row g-1">
                  <div className="col-8">Mens Jewellery</div>
                  <div
                    className="col-4 pointer-cursor"
                    onClick={() =>
                      window.open(
                        "https://sencogoldanddiamonds.com/jewellery/category/aham-collection",
                        "_blank"
                      )
                    }
                  >
                    <a>SHOP NOW</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className={styles.our_collecttions_card}>
              <figure>
                <Image
                  src={require("@/assets/images/Our-Collections/Bag.jpg")}
                  alt="our collecttions"
                />
              </figure>
              <div className={styles.our_collecttions_text}>
                <div className="row g-1">
                  <div className="col-8">Bag</div>
                  <div
                    className="col-4 pointer-cursor"
                    onClick={() =>
                      window.open(
                        "https://www.sennes.in/category/bags-and-accessories",
                        "_blank"
                      )
                    }
                  >
                    <a>SHOP NOW</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className={styles.our_collecttions_card}>
              <figure>
                <Image
                  src={require("@/assets/images/Our-Collections/Everyday-Fine-Jewellry.jpg")}
                  alt="our collecttions"
                />
              </figure>
              <div className={styles.our_collecttions_text}>
                <div className="row g-1">
                  <div className="col-8">Everyday Fine Jewellry</div>
                  <div
                    className="col-4 pointer-cursor"
                    onClick={() =>
                      window.open("https://everlite.com/", "_blank")
                    }
                  >
                    <a>SHOP NOW</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className={styles.our_collecttions_card}>
              <figure>
                <Image
                  src={require("@/assets/images/Our-Collections/Lab-Grown-Diamonds.jpg")}
                  alt="our collecttions"
                />
              </figure>
              <div className={styles.our_collecttions_text}>
                <div className="row g-1">
                  <div className="col-8">Lab Grown Diamonds</div>
                  <div
                    className="col-4 pointer-cursor"
                    onClick={() =>
                      window.open(
                        "https://www.sennes.in/collections/lab-grown-diamonds-jewellery",
                        "_blank"
                      )
                    }
                  >
                    <a>SHOP NOW</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Collecttions;
